import { render, staticRenderFns } from "./moveEdit.vue?vue&type=template&id=cb7c67b8&"
import script from "./moveEdit.vue?vue&type=script&lang=js&"
export * from "./moveEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports